import { ImageOff, Lightbulb, ScanFace, Upload } from 'lucide-react';
import ErrorState from './ErrorState';
import { PRIMARY_BUTTON, MICRO_LABEL } from '../constants';

const InvalidImage = ({ onChooseAnother }) => (
    <ErrorState
        icon={ImageOff}
        title="This photo can't be used"
        actions={
            <button type="button" onClick={onChooseAnother} className={PRIMARY_BUTTON}>
                <Upload className="w-3.5 h-3.5" />
                <span className={MICRO_LABEL}>Choose Another Photo</span>
            </button>
        }
    >
        <p className="mb-3">Improper photo, this may be due to</p>
        <ul className="text-left inline-flex flex-col gap-2">
            <li className="flex items-center gap-2.5">
                <Lightbulb className="w-4 h-4 shrink-0 text-[#839282]" />
                Poor lighting
            </li>
            <li className="flex items-center gap-2.5">
                <ScanFace className="w-4 h-4 shrink-0 text-[#839282]" />
                The face isn&apos;t clear, or the angle is off
            </li>
        </ul>
    </ErrorState>
);

export default InvalidImage;
